$(window).resize(function(){
  headerChange();
})

function headerChange(){
  let $header = $('.header-wrapper')
  if($(window).width() <= 768 && $header.hasClass('overlay--active')){
    $header.removeClass('header-wrapper--overlay');
    $header.removeClass('overlay--active')
  }else if($(window).width() > 768 && !$header.hasClass('overlay--active')){
    $header.addClass('header-wrapper--overlay');
    $header.addClass('overlay--active')
  }
}

$(document).ready(function(){
  headerChange();
})

//append checklist on widget load (old Bold Recurring Orders widget)
if (typeof BOLD !== 'undefined' && BOLD.common && BOLD.common.eventEmitter) {
BOLD.common.eventEmitter.on("BOLD_RECURRING_ORDERS_widget_loaded", function () {
  let checkSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>`
  let checklistTemplate = "";
  let oneTimeChecklistTemplate = "";
  console.log(subscription,onetime);
  if(subscription == ""){
   checklistTemplate = 
    `<ul class="product-subscription-checklist">
      <li>${checkSVG} <span>10% off every order</span></li>
      <li>${checkSVG} <span>Special VIP offers</span></li>
      <li>${checkSVG} <span>Pause, skip or cancel anytime</span></li>
      <li>${checkSVG} <span>Delivery right to your door</span></li>
    </ul>`;
  }else{
      checklistTemplate += `<ul class="product-subscription-checklist">`;
      subscription.split(",").forEach((data) => {
         checklistTemplate += `<li>${checkSVG} <span>${data}</span></li>`
      })
    checklistTemplate += `</ul>`;
  }  

  if(onetime == ""){
   oneTimeChecklistTemplate = `<ul class="product-subscription-checklist">
      <li>${checkSVG} <span>Plant-based electrolytes</span></li>
      <li>${checkSVG} <span>Clean ingredients-- nothing artificial</span></li>
      <li>${checkSVG} <span>Hydrates & nourishes</span></li>
      <li>${checkSVG} <span>Certified organic</span></li>
    </ul>`;
  }else{
      oneTimeChecklistTemplate += `<ul class="product-subscription-checklist">`;
      onetime.split(",").forEach((data) => {
         oneTimeChecklistTemplate += `<li>${checkSVG} <span>${data}</span></li>`
      })
    oneTimeChecklistTemplate += `</ul>`;
  }
  $('.bold-ro__radio-div.bold-ro__recurring-div').append($(checklistTemplate));
  $('.bold-ro__radio-div.bold-ro__one-time-div').append($(oneTimeChecklistTemplate));
});
}

// Product ATC row — qty + button layout, price updates, loading state
(function () {
  function initAtcRow() {
    var info = document.querySelector('.product-info-wrapper');
    if (!info) return;

    var qty = info.querySelector('.quantity-controls__outer');
    var submit = info.querySelector('.product-page--submit-action');
    if (!qty || !submit || qty.closest('.product-atc-row')) return;

    var row = document.createElement('div');
    row.className = 'product-atc-row';
    qty.parentNode.insertBefore(row, qty);
    row.appendChild(qty);
    row.appendChild(submit);
  }

  function getMoneyFormat() {
    var global = document.getElementById('wetheme-global');
    if (!global) return '${{amount}}';
    try {
      return JSON.parse(global.textContent).moneyFormat || '${{amount}}';
    } catch (e) {
      return '${{amount}}';
    }
  }

  function parseMoneyToCents(str) {
    if (!str) return 0;
    var cleaned = String(str).replace(/[^\d.,]/g, '');
    if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) {
      cleaned = cleaned.replace(/,/g, '');
    } else if (cleaned.indexOf(',') > -1) {
      cleaned = cleaned.replace(',', '.');
    }
    var amount = parseFloat(cleaned);
    return isNaN(amount) ? 0 : Math.round(amount * 100);
  }

  function formatMoney(cents) {
    var format = getMoneyFormat();
    var amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function getCurrentVariant() {
    var productScript = document.querySelector('.product-json');
    var form = document.getElementById('add-to-cart-form');
    if (!productScript || !form) return null;

    try {
      var product = JSON.parse(productScript.textContent);
      var idInput = form.querySelector('[name="id"]');
      var variantId = idInput ? parseInt(idInput.value, 10) : null;
      if (!variantId || !product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === variantId) return product.variants[i];
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  function getQuantity() {
    var input = document.getElementById('quantity');
    var qty = input ? parseInt(input.value, 10) : 1;
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function getSelectedSellingPlanPriceCents(variant, widget) {
    if (window.BerriVariantPricing) {
      return window.BerriVariantPricing.getSubscribePriceCents(widget);
    }

    if (!variant || !widget) return null;

    var frequency = widget.querySelector('input[data-bsub-delivery-frequency-option]:checked');
    if (!frequency) return null;

    if (variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
      for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
        var allocation = variant.selling_plan_allocations[i];
        var planId = allocation.selling_plan_id ||
          (allocation.selling_plan && allocation.selling_plan.id);
        if (String(planId) === String(frequency.value)) {
          var price = allocation.per_delivery_price != null
            ? allocation.per_delivery_price
            : allocation.price;
          if (price != null) return price;
        }
      }
    }

    return null;
  }

  function getAtcUnitPriceCents() {
    if (window.BerriVariantPricing) {
      return window.BerriVariantPricing.getActiveUnitPriceCents();
    }

    var widget = document.querySelector('.bsub-widget');
    var oneTimeChecked = document.querySelector('[data-bsub-purchase-option-one-time]:checked');
    var variant = getCurrentVariant();

    if (widget && !oneTimeChecked) {
      var allocationPrice = getSelectedSellingPlanPriceCents(variant, widget);
      if (allocationPrice != null) return allocationPrice;

      var frequency = widget.querySelector('input[data-bsub-delivery-frequency-option]:checked');
      if (frequency) {
        var container = frequency.closest('.bsub-option-container');
        var perDelivery = container && container.querySelector('[data-bsub-per-delivery-price]');
        if (perDelivery && perDelivery.textContent.trim()) {
          return parseMoneyToCents(perDelivery.textContent.trim());
        }
      }
      var subscribePrice = widget.querySelector('[data-bsub-selling-plan-group] .bsub-widget__group-price');
      if (subscribePrice && subscribePrice.textContent.trim()) {
        return parseMoneyToCents(subscribePrice.textContent.trim());
      }
    }

    if (variant && variant.price) return variant.price;

    var priceEl = document.querySelector('.product-page--pricing--variant-price .money');
    return priceEl ? parseMoneyToCents(priceEl.textContent.trim()) : 0;
  }

  function getAtcButtonText(btn) {
    var label = btn.dataset.atcLabel || 'Add to cart';
    var price = formatMoney(getAtcUnitPriceCents() * getQuantity());
    return price ? label + ' - ' + price : label;
  }

  function getAtcButton() {
    return document.getElementById('purchase');
  }

  function getAtcSubmitAction() {
    var btn = getAtcButton();
    return btn && btn.closest('.product-page--submit-action');
  }

  function ensureAtcStructure() {
    var btn = getAtcButton();
    var tpl = document.getElementById('atc-button-content-template');
    if (!btn || !tpl || !btn.hasAttribute('data-atc-custom')) return;
    if (btn.querySelector('.add-to-cart-btn__text')) return;

    btn.innerHTML = '';
    btn.appendChild(tpl.content.cloneNode(true));
  }

  function updateAtcPrice() {
    var btn = getAtcButton();
    if (!btn) return;

    ensureAtcStructure();

    var textEl = btn.querySelector('.add-to-cart-btn__text');
    if (!textEl) return;

    textEl.textContent = getAtcButtonText(btn);
  }

  function setAtcLoading(isLoading) {
    var submitAction = getAtcSubmitAction();
    var btn = getAtcButton();
    if (!submitAction || !btn) return;

    submitAction.classList.toggle('product-page--submit-action--loading', isLoading);
    btn.classList.toggle('add-to-cart-btn--loading', isLoading);
    btn.classList.toggle('add-to-cart-btn--pressed', isLoading);

    var loader = submitAction.querySelector('.add-to-cart-btn__loader');
    if (loader) loader.classList.toggle('hide', !isLoading);
  }

  function resetProductQuantity() {
    var input = document.getElementById('quantity');
    if (!input || input.value === '1') return;

    input.value = '1';
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onAtcComplete() {
    setAtcLoading(false);
    ensureAtcStructure();
    updateAtcPrice();
  }

  function bindAtcButton() {
    var btn = getAtcButton();
    if (!btn || btn.dataset.atcInit) return;
    btn.dataset.atcInit = 'true';

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      setAtcLoading(true);
    });
  }

  function bindAtcEvents() {
    var form = document.getElementById('add-to-cart-form');
    if (!form) return;

    form.addEventListener('change', updateAtcPrice);
    document.addEventListener('variantAvailable', function () {
      setTimeout(updateAtcPrice, 250);
    });
    document.addEventListener('bsubWidgetUpdated', updateAtcPrice);

    var qtyControls = document.querySelector('.product-info-wrapper .quantity-controls');
    if (qtyControls && !qtyControls.dataset.priceBound) {
      qtyControls.dataset.priceBound = 'true';
      qtyControls.addEventListener('click', function (e) {
        if (e.target.closest('.qty-plus') || e.target.closest('.qty-minus')) {
          updateAtcPrice();
        }
      });
    }

    var qtyInput = document.getElementById('quantity');
    if (qtyInput) {
      qtyInput.addEventListener('change', updateAtcPrice);
    }

    var cartSlideout = document.getElementById('cartSlideoutWrapper');
    if (cartSlideout) {
      cartSlideout.addEventListener('cart:open', onAtcComplete);
    }

    if (!window.__atcFetchBound) {
      window.__atcFetchBound = true;
      var originalFetch = window.fetch;
      window.fetch = function () {
        var response = originalFetch.apply(this, arguments);
        var url = arguments[0];

        if (typeof url === 'string' && url.indexOf('/cart/add') > -1) {
          response
            .then(function (res) {
              if (res && res.ok) resetProductQuantity();
            })
            .finally(function () {
              setTimeout(onAtcComplete, 0);
              setTimeout(onAtcComplete, 500);
            });
        }

        return response;
      };
    }
  }

  function initProductAtc() {
    initAtcRow();
    bindAtcButton();
    bindAtcEvents();
    updateAtcPrice();
    setTimeout(updateAtcPrice, 500);
  }

  if (!document.getElementById('add-to-cart-form')) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAtc);
  } else {
    initProductAtc();
  }
})();

// Gallery grid — tap thumb to update main image (mobile/tablet)
(function () {
  function initGalleryGrid() {
    var gallery = document.querySelector('.product-gallery-grid');
    if (!gallery) return;

    var mainItems = gallery.querySelectorAll('.product-gallery-grid__main .product-gallery-grid__item');
    var thumbs = gallery.querySelectorAll('.product-gallery-grid__thumbs .product-gallery-grid__item');
    if (!thumbs.length) return;

    function setActive(mediaId) {
      mainItems.forEach(function (item) {
        item.classList.toggle('product-gallery-grid__item--active', item.dataset.mediaId === mediaId);
      });
      thumbs.forEach(function (item) {
        item.classList.toggle('product-gallery-grid__item--active', item.dataset.mediaId === mediaId);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActive(thumb.dataset.mediaId);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryGrid);
  } else {
    initGalleryGrid();
  }
})();

// Hide Shopify subscription disclaimer in cart drawer — keep shop button visible
(function () {
  var disclaimerPattern = /deferred, subscription, or recurring purchase|authorize you to charge my payment method/i;
  var SCROLLABLE_ITEM_COUNT = 4;
  var disclaimerHiddenStyle = 'display:none!important;visibility:hidden!important;height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;border:0!important;';

  function markDisclaimerHidden(node) {
    if (!node || isShopPayContainer(node)) return;
    if (node.classList.contains('cart-drawer__subscription-disclaimer')) return;
    node.classList.add('cart-drawer__subscription-disclaimer');
    node.style.cssText = disclaimerHiddenStyle;
    node.setAttribute('aria-hidden', 'true');
    node.hidden = true;
  }

  function isShopPayContainer(node) {
    if (!node || !node.classList) return false;
    if (node.classList.contains('dynamic-checkout__content')) return true;
    if (node.classList.contains('wallet-button-wrapper')) return true;
    if (node.classList.contains('wallet-cart-grid')) return true;
    if (node.classList.contains('wallet-cart-button-container')) return true;
    if (node.classList.contains('wallet-cart-button')) return true;
    if (node.classList.contains('additional-checkout-buttons')) return true;
    if (node.classList.contains('shopify-cleanslate')) return true;
    if (node.tagName === 'SHOPIFY-ACCELERATED-CHECKOUT-CART') return true;
    if (node.closest('.dynamic-checkout__content, shopify-accelerated-checkout-cart, .wallet-button-wrapper, .additional-checkout-buttons, .shopify-cleanslate')) return true;
    return false;
  }

  function ensureShopPayVisible(root) {
    if (!root) return;
    var checkout = root.querySelector('.additional-checkout-buttons');
    if (!checkout) return;

    checkout.classList.remove('cart-drawer__subscription-disclaimer', 'hide');
    checkout.hidden = false;
    checkout.style.removeProperty('display');
    checkout.style.removeProperty('visibility');
    checkout.style.removeProperty('height');
    checkout.style.removeProperty('max-height');
    checkout.style.removeProperty('overflow');

    checkout.querySelectorAll(
      '.dynamic-checkout__content, shopify-accelerated-checkout-cart, .wallet-button-wrapper, .wallet-cart-grid, .wallet-cart-button-container, .wallet-cart-button, .shopify-cleanslate, ul[data-shopify-buttoncontainer="true"]'
    ).forEach(function (node) {
      node.classList.remove('cart-drawer__subscription-disclaimer');
      node.hidden = false;
      node.style.removeProperty('display');
      node.style.removeProperty('visibility');
      node.style.removeProperty('height');
      node.style.removeProperty('max-height');
      node.style.removeProperty('overflow');
      node.style.removeProperty('opacity');
    });
  }

  function hideCartSubscriptionDisclaimer(root) {
    if (!root) return;

    ensureShopPayVisible(root);

    var buyerConsent = document.getElementById('shopify-buyer-consent');
    if (buyerConsent) {
      markDisclaimerHidden(buyerConsent);
    }

    root.querySelectorAll('.ajax-cart--bottom-wrapper p, .additional-checkout-buttons p').forEach(function (node) {
      if (node.classList.contains('taxes-and-shipping-message') || node.classList.contains('cart--shipping-message')) return;
      if (isShopPayContainer(node)) return;
      var text = (node.textContent || '').trim();
      if (disclaimerPattern.test(text) && text.length < 700) {
        markDisclaimerHidden(node);
      }
    });

    ensureShopPayVisible(root);
  }

  function updateCartDrawerScrollState() {
    var wrapper = document.getElementById('cartSlideoutWrapper');
    if (!wrapper) return;

    var itemCount = wrapper.querySelectorAll('.cart-items > li').length;
    wrapper.classList.toggle('cart-drawer--scrollable', itemCount >= SCROLLABLE_ITEM_COUNT);
  }

  function updateCartDrawerEmptyState() {
    var wrapper = document.getElementById('cartSlideoutWrapper');
    if (!wrapper) return;

    var emptyBox = wrapper.querySelector('.cart-empty-box');
    var isEmpty = emptyBox && !emptyBox.classList.contains('hide');
    wrapper.classList.toggle('cart-drawer--empty', isEmpty);
  }

  function bindCartEmptyContinue() {
    var continueBtn = document.querySelector('.cart-empty-box__continue');
    if (!continueBtn || continueBtn.dataset.bound) return;
    continueBtn.dataset.bound = 'true';

    continueBtn.addEventListener('click', function () {
      var closeBtn = document.querySelector('#cartSlideoutWrapper .cart-menu-close');
      if (closeBtn) closeBtn.click();
    });
  }

  function setCartItemQtyLoading(cartItem) {
    if (!cartItem) return;
    var priceWrapper = cartItem.querySelector('.cart-item-line-total-wrapper');
    var qtyWrapper = cartItem.querySelector('.cart-item--quantity-wrapper');
    if (priceWrapper) {
      priceWrapper.classList.add('cart-item-line-total-wrapper--loading');
      priceWrapper.setAttribute('aria-busy', 'true');
    }
    if (qtyWrapper) {
      qtyWrapper.classList.add('cart-item-quantity-active');
      qtyWrapper.setAttribute('aria-busy', 'true');
    }
  }

  function clearAllCartItemQtyLoading() {
    document.querySelectorAll('#cartSlideoutWrapper .cart-item-line-total-wrapper--loading').forEach(function (wrapper) {
      wrapper.classList.remove('cart-item-line-total-wrapper--loading');
      wrapper.removeAttribute('aria-busy');
    });
    document.querySelectorAll('#cartSlideoutWrapper .cart-item--quantity-wrapper.cart-item-quantity-active').forEach(function (wrapper) {
      wrapper.classList.remove('cart-item-quantity-active');
      wrapper.removeAttribute('aria-busy');
    });
    if (window.__cartQtyLoadingFallback) {
      clearTimeout(window.__cartQtyLoadingFallback);
      window.__cartQtyLoadingFallback = null;
    }
  }

  function scheduleCartQtyLoadingFallback() {
    if (window.__cartQtyLoadingFallback) {
      clearTimeout(window.__cartQtyLoadingFallback);
    }
    window.__cartQtyLoadingFallback = setTimeout(clearAllCartItemQtyLoading, 5000);
  }

  function updateCartMinusButtons() {
    document.querySelectorAll('#cartSlideoutWrapper .cart-item').forEach(function (cartItem) {
      var qtyInput = cartItem.querySelector('.cart-item-quantity');
      var minusBtn = cartItem.querySelector('.cart-item-decrease');
      if (!qtyInput || !minusBtn) return;

      var qty = parseInt(qtyInput.value, 10);
      var isMin = isNaN(qty) || qty <= 1;
      minusBtn.disabled = isMin;
      minusBtn.setAttribute('aria-disabled', isMin ? 'true' : 'false');
      minusBtn.classList.toggle('cart-item-decrease--disabled', isMin);
    });
  }

  function bindCartMinusDisable(cartDrawer) {
    if (!cartDrawer || cartDrawer.dataset.minusDisableBound) return;
    cartDrawer.dataset.minusDisableBound = 'true';

    cartDrawer.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('.cart-item-decrease');
      if (!minusBtn) return;

      var cartItem = minusBtn.closest('.cart-item');
      var qtyInput = cartItem && cartItem.querySelector('.cart-item-quantity');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      if (isNaN(qty) || qty <= 1) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    cartDrawer.addEventListener('click', function (e) {
      if (!e.target.closest('.cart-item-quantity-button')) return;
      setTimeout(updateCartMinusButtons, 0);
    });
  }

  function bindCartQuantityLoading(cartDrawer) {
    if (!cartDrawer || cartDrawer.dataset.qtyLoaderBound) return;
    cartDrawer.dataset.qtyLoaderBound = 'true';

    cartDrawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.cart-item-quantity-button');
      if (qtyBtn) {
        setCartItemQtyLoading(qtyBtn.closest('.cart-item'));
        return;
      }

      if (e.target.closest('#cart-item-remove-button')) {
        setCartItemQtyLoading(e.target.closest('.cart-item'));
      }
    });
  }

  function bindCartQuantityFetchHook() {
    if (window.__cartQtyFetchBound) return;
    window.__cartQtyFetchBound = true;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var response = originalFetch.apply(this, arguments);
      var url = arguments[0];

      if (typeof url === 'string' && url.indexOf('/cart/update.js') > -1) {
        scheduleCartQtyLoadingFallback();

        response
          .then(function (res) {
            if (!res || !res.ok) {
              clearAllCartItemQtyLoading();
            }
            return res;
          })
          .catch(function () {
            clearAllCartItemQtyLoading();
          });
      }

      return response;
    };
  }

  function initCartDrawerLayout() {
    var cartDrawer = document.getElementById('cartSlideoutWrapper');
    if (!cartDrawer || cartDrawer.dataset.layoutBound) return;
    cartDrawer.dataset.layoutBound = 'true';

    var disclaimerTimer;
    function scheduleDisclaimerHide() {
      clearTimeout(disclaimerTimer);
      disclaimerTimer = setTimeout(function () {
        hideCartSubscriptionDisclaimer(cartDrawer);
      }, 150);
    }

    hideCartSubscriptionDisclaimer(cartDrawer);
    updateCartDrawerScrollState();
    updateCartDrawerEmptyState();
    bindCartEmptyContinue();
    bindCartMinusDisable(cartDrawer);
    bindCartQuantityLoading(cartDrawer);
    bindCartQuantityFetchHook();
    updateCartMinusButtons();

    var disclaimerObserver = new MutationObserver(scheduleDisclaimerHide);
    disclaimerObserver.observe(cartDrawer, { childList: true, subtree: true });

    var emptyBox = cartDrawer.querySelector('.cart-empty-box');
    if (emptyBox) {
      var emptyObserver = new MutationObserver(updateCartDrawerEmptyState);
      emptyObserver.observe(emptyBox, { attributes: true, attributeFilter: ['class'] });
    }

    var itemsList = cartDrawer.querySelector('.cart-items');
    if (itemsList) {
      var itemsObserver = new MutationObserver(function (mutations) {
        var itemsRebuilt = mutations.some(function (mutation) {
          return mutation.type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0);
        });
        if (!itemsRebuilt) return;
        clearAllCartItemQtyLoading();
        updateCartMinusButtons();
        updateCartDrawerScrollState();
        updateCartDrawerEmptyState();
      });
      itemsObserver.observe(itemsList, { childList: true });
    }

    ['cart:updated', 'cart:refresh'].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        updateCartMinusButtons();
        updateCartDrawerScrollState();
        updateCartDrawerEmptyState();
      });
    });

    cartDrawer.addEventListener('cart:drawer:updated', function () {
      updateCartMinusButtons();
      updateCartDrawerScrollState();
      updateCartDrawerEmptyState();
    });

    var htmlObserver = new MutationObserver(function () {
      if (document.documentElement.classList.contains('slideout-open')) {
        updateCartDrawerScrollState();
        updateCartDrawerEmptyState();
        scheduleDisclaimerHide();
      }
    });
    htmlObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    setTimeout(updateCartDrawerScrollState, 0);
    setTimeout(updateCartDrawerEmptyState, 0);
    setTimeout(scheduleDisclaimerHide, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerLayout);
  } else {
    initCartDrawerLayout();
  }
})();
